document.addEventListener("DOMContentLoaded", () => {
  const toggler = document.getElementById("mobile-filters-toggler");
  const filters = document.querySelector(".mobile-filters");
  const closeBtn = document.querySelector(".close-filters");
  const applyBtn = document.querySelector(".use-filters-container");

  // Open filters
  toggler.addEventListener("click", () => {
    filters.classList.add("opened");
  });

  // Close filters on close button
  closeBtn.addEventListener("click", () => {
    filters.classList.remove("opened");
  });

  // Optional: Close filters on "Застосувати" button
  applyBtn.addEventListener("click", () => {
    filters.classList.remove("opened");
  });
});
